module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_7_2.9ca1f33a.jpeg";